<template>
  <div>
    <Buscador v-if="show_buscador" @search="get_productos"/>
    <!-- Tabla de productos -->
    <v-data-table
        :headers="tabla.headers"
        :items="tabla.productos"
        :options.sync="tabla.options"
        :server-items-length="tabla.count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
    >
      <template v-slot:item="{ item }">
        <tr :class="get_class(item)" @click="$emit('on_click_selected', item)">
          <td>{{ item.nombre }}</td>
          <td>{{ item.categoria.nombre }}</td>
          <td v-if="!is_escandallo">{{ item.barcode }}</td>
          <td v-if="!is_escandallo">{{ item.ref }}</td>
          <td v-if="!is_pedido">{{ item.precio | money }}</td>
          <td v-if="!is_venta">{{ item.precio_coste | money }}</td>
          <td>
            <v-row justify="space-between" style="display: inline-block; text-align: center; width: 100%">
              <v-btn
                  v-if="(is_escandallo ) || show_btn_modificar_stock"
                  icon
                  x-small
                  color="green"
                  @click="update_stock(item, 1)"
                  class="mr-1">
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>

              <span
                  @click="(is_escandallo ) || show_btn_modificar_stock?open_dialog_edit_stock(item):''"
                  :title="$t('Editar stock')"
                  :style="(is_escandallo) || show_btn_modificar_stock?{cursor: 'pointer'}:''"
              >{{ item.stocks.existencias }}</span>

              <v-btn
                  v-if="(is_escandallo) || show_btn_modificar_stock"
                  icon
                  color="red"
                  x-small
                  @click="update_stock(item, -1)"
                  class="ml-1"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </v-row>
          </td>
          <td v-if="!is_escandallo" class="text-center">
            <span
                @click="is_editable?open_dialog_stock_minimo(item):''"
                :style="is_editable?{cursor: 'pointer'}:''"
                :title="$t('Editar stock')"
            >{{ item.stocks.stock_minimo }}</span>
          </td>
          <td v-if="is_editable">
            <v-btn icon @click="$emit('on_click_edit', item)" color="primary" :title="$t('Editar')">
              <v-icon
              >mdi-pencil
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:footer.prepend>
        <div class="container_info_azul" style="width: 50vh">
          <v-row>
            <v-col>
              <span class="negrita">{{ $t('Valor stock en venta') }}</span>: {{ valor_venta | money }}
            </v-col>
            <v-col>
              <span class="negrita">{{ $t('Valor stock en coste') }}</span>: {{ valor_coste | money }}
            </v-col>
          </v-row>
        </div>
      </template>
    </v-data-table>

    <DialogStockMinimo
        v-if="dialog_stock_minimo"
        v-model="dialog_stock_minimo"
        :item="item_stock_minimo"
        @on_click_save_stock_minimo="on_click_save_stock_minimo"
    />

    <DialogStockEdit
        v-if="dialog_stock_edit"
        v-model="dialog_stock_edit"
        :item="item_stock_edit"
        @on_click_edit_stock="function (item, cantidad, descripcion){update_stock(item,cantidad, descripcion); $data.dialog_stock_edit=false}"
    />

  </div>
</template>


<script>
export default {
  name: 'TablaProductos',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    show_buscador: {
      type: Boolean,
      default: false
    },
    is_venta: {
      type: Boolean,
      default: false
    },
    is_pedido: {
      type: Boolean,
      default: false
    },
    is_escandallo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabla: {
      productos: [],
      count: 0,
      headers: [],
      filtros: {},
      options: {
        itemsPerPage: 10
      }
    },
    dialog_stock_minimo: false,
    item_stock_minimo: null,
    dialog_stock_edit: false,
    item_stock_edit: null,
    valor_venta: 0,
    valor_coste: 0
  }),

  methods: {
    /**
     * Recupera los productos de la api
     */
    async get_productos(search = null) {
      if(search)
        this.tabla.filtros['search'] = search
      let filtros = { ...this.tabla.filtros, ...this.selected_filters }

      const response = await this.$store.dispatch("producto/get_productos", {
        params: filtros
      });

      this.tabla.productos = response.results;
      this.tabla.count = response.count;
      this.$emit('on_total', response.count)
    },

    /**
     * Actualiza el stock del producto
     * @param item
     * @param increment
     * @returns {Promise<void>}
     */
    async update_stock(item, increment, descripcion='') {
      let producto = {
        id: item.id,
        stocks: {
          existencias: item.stocks.existencias + increment
        },
        descripcion: descripcion
      };

      // si es escandallo se modifica al cobrar la venta, así se deshacen los cambios al cancelar la venta
      if (this.is_escandallo) {
        this.$emit('modificar_stock', producto)
        item.stocks.existencias += increment;
        return
      }

      try {
        await this.$store.dispatch("producto/save", producto);
        await this.get_valor_coste_venta()
        item.stocks.existencias += increment;
	      this.$snotify.success(
		      this.$t("Acción realizada con éxito"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },

    /**
     * Devuelve la clase que corresponde a cada fila de la tabla
     * @param item
     * @returns {string}
     */
    get_class(item) {
      if (!item.is_active) {
        return "red--text text-decoration-line-through";
      } else {
        if (item.stocks.existencias < item.stocks.stock_minimo)
          return "red--text";
      }
    },

    open_dialog_stock_minimo(item) {
      this.dialog_stock_minimo = true
      this.item_stock_minimo=item
    },

    open_dialog_edit_stock(item) {
      this.dialog_stock_edit = true
      this.item_stock_edit=item
    },

    on_click_save_stock_minimo(){
      this.dialog_stock_minimo = false
      this.get_productos()
    },

    async get_valor_coste_venta () {
      try{
        const response = await this.$store.dispatch("producto/get_valor_coste_venta");
        this.valor_coste = response.precio_coste
        this.valor_venta = response.precio_venta
      }catch (e) {
        console.log(e)
      }
    }
  },

  mounted() {
    this.tabla.headers = [
      { text: this.$t("Nombre"), value: "nombre", class: "primary white--text"},
      { text: this.$t("Categoría"), value: "categoria.nombre", class: "primary white--text" },
    ]
    if(!this.is_escandallo){
      this.tabla.headers.push({ text: this.$t("Código de barras"), value: "barcode", class: "primary white--text" })
      this.tabla.headers.push({ text: this.$t("Referencia"), value: "ref", class: "primary white--text" })
    }
    if(!this.is_pedido) {
      this.tabla.headers.push({text: this.$t("Precio"), value: "precio", class: "primary white--text"})
    }
    if(!this.is_venta){
      this.tabla.headers.push({ text: this.$t("Coste"), value: "precio_coste", class: "primary white--text" })
    }
    this.tabla.headers.push(
      { text: this.$t("Stock"), value: "stocks.existencias", class: "primary white--text", width: "100px" }
    )
    if(!this.is_escandallo){
      this.tabla.headers.push({ text: this.$t("Stock mínimo"), value: "stocks.stock_minimo", class: "primary white--text", align: "center" })
    }
    this.tabla.headers.push({ text: "", value: "actions", class: "primary white--text", width: "10px" })

    // Si no es editable (caso venta) eliminamos la columna de acciones
    if(!this.is_editable) {
      this.tabla.headers.pop()
    }
  },

  computed: {
    is_editable(){
      return (!this.is_venta && !this.is_pedido) && (this.$store.state.auth.user.tipo_empleado === 'admin' ||
          this.$store.getters['auth/has_permission']('editar_concepto_venta'))
    },
    show_btn_modificar_stock() {
      return (((!this.is_venta || this.is_escandallo)) && (this.$store.state.auth.user.tipo_empleado === 'admin'
          || this.$store.getters['auth/has_permission']("modificar_stock")))
    }
  },

  watch: {
    'tabla.options': {
      handler(value) {
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_productos()
        this.get_valor_coste_venta()
      },
    },
  },

  components: {
    DialogStockMinimo: () => import('@/views/Configuracion/Productos/Productos/components/DialogStockMinimo'),
    DialogStockEdit: () => import('@/views/Configuracion/Productos/MovimientosStock/DialogStockEdit')
  }
}
</script>
